import * as React from 'react';
import { ProductSizeInterface } from '../../../../Interface/ProductSize';
import { BrandInterface } from '../../../../Interface/Brand';
import { Col} from 'react-bootstrap';
import ProductNameRow from './ProductNameRow/ProductNameRow';
import ProductDetailsRow from './ProductDetailsRow/ProductDetailsRow';
export default function ProductSizeDetails({
  brand,
  product_size,
  onUpdate
}: {
  brand?: BrandInterface;
  product_size: ProductSizeInterface;
  onUpdate?: () => void;
}) {
  
  return (
    <Col className="order-md-1 order-lg-2" xs={12} lg={8} xxl={9}>
      <ProductNameRow brand={brand} product_size={product_size} />
      <ProductDetailsRow product_size={product_size} onUpdate={onUpdate} />
    </Col>
  );
}
